import { CaseData } from "@/cms/models";
import {
  faLinkedin as squareFaLinkedin,
  faSquareFacebook,
  faSquareXTwitter,
  faLinkedinIn,
  faFacebookF,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareEnvelope,
  faEnvelope,
} from "@fortawesome/sharp-light-svg-icons";
import Link from "next/link";
import React from "react";

interface SomeSharingLinksProps {
  encodedFullUrl: string;
  style?: "square" | "default";
  caseData: CaseData;
  somelinks: string[];
  /** The icons take the section's own text colour instead of the page's. */
  followsSectionText?: boolean;
}

const SomeSharingLinks: React.FC<SomeSharingLinksProps> = ({
  encodedFullUrl,
  style = "square",
  caseData,
  somelinks,
  followsSectionText = false,
}) => {
  const getSize = () => {
    return style === "square" ? "size-6" : "size-5";
  };

  const getMailtoLink = (caseData: CaseData) => {
    const subject = `Se denne ejendom: ${caseData.advertisementAddressOrDisplayName}`;
    const body = `Hej%0D%0A%0D%0ASe denne bolig, jeg har fundet på:%0D%0A${encodedFullUrl}`;
    return `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <div
      className={
        followsSectionText
          ? "flex text-[var(--section-text-color)] justify-end items-center gap-1.5"
          : "flex text-[var(--page-text-color)] justify-end items-center gap-1.5"
      }
    >
      {somelinks.some((x) => x === "linkedin") && (
        <Link
          aria-label="Share on linkedin"
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedFullUrl}`}
          className="hover:text-[var(--button-hover-text-color)] flex items-center"
          target="_blank"
        >
          <FontAwesomeIcon
            className={getSize()}
            icon={style === "square" ? squareFaLinkedin : faLinkedinIn}
          />
        </Link>
      )}
      {somelinks.some((x) => x === "twitter") && (
        <Link
          aria-label="Share on x"
          href={`https://x.com/intent/tweet?url=${encodedFullUrl}`}
          className="hover:text-[var(--button-hover-text-color)] flex items-center"
          target="_blank"
        >
          <FontAwesomeIcon
            className={getSize()}
            icon={style === "square" ? faSquareXTwitter : faXTwitter}
          />
        </Link>
      )}
      {somelinks.some((x) => x === "facebook") && (
        <Link
          aria-label="Share on facebook"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedFullUrl}`}
          className="hover:text-[var(--button-hover-text-color)] flex items-center"
          target="_blank"
        >
          <FontAwesomeIcon
            className={getSize()}
            icon={style === "square" ? faSquareFacebook : faFacebookF}
          />
        </Link>
      )}
      {somelinks.some((x) => x === "mail") && caseData?.agent?.email && (
        <a
          aria-label="Send email"
          href={getMailtoLink(caseData)}
          className="hover:text-[var(--button-hover-text-color)] flex items-center"
          target="_blank"
        >
          <FontAwesomeIcon
            className={getSize()}
            icon={style === "square" ? faSquareEnvelope : faEnvelope}
          />
        </a>
      )}
    </div>
  );
};

export default SomeSharingLinks;
